exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\na[data-v-e7579978]{\n    text-decoration: underline;\n}\n.table td[data-v-e7579978]{\n    vertical-align: inherit;\n    padding: 7px;\n}\n.anchorDisabled[data-v-e7579978]{\n    background-color: #6c757d;\n    opacity: 0.65;\n    border: none;\n}\n@media screen and (max-width: 896px) {\n.sp_label[data-v-e7579978]{\n      min-width: 10rem;\n}\n}\n", ""]);

// exports
